export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const CHANGE_DOCUMENT = "CHANGE_DOCUMENT";
export const SET_DOCUMENT = "SET_DOCUMENT";
export const SET_FILE = 'SET_FILE'
export const SET_INITIAL_DOCUMENT = 'SET_INITIAL_DOCUMENT'